<template>
  <div>
    <h3 class="uk-text-center uk-text-danger uk-animation-shake" v-if="showError">
      Je kunt er maximaal drie selecteren. Deselecteer eerst een andere keuze. <br>
      Wil je meer wensen doorgeven? Dan kan dit op de volgende pagina.
    </h3>
    <div class="uk-child-width-1-2 uk-child-width-1-4@m uk-grid-column-medium" uk-grid>
      <ToneOfVoiceSelectorButton
        v-for="{value, icon, audioFile, audioName} in toneOfVoices" :key="value"
        :icon="icon"
        :value="value"
        :audioFile="audioFile"
        :audioName="audioName"
        @click="select"
      />
    </div>
  </div>
</template>

<script>
import ToneOfVoiceSelectorButton from '@/components/ToneOfVoiceSelectorButton.vue';
import { generate as uniqueid } from 'shortid';

const toneOfVoices = [
  {
    value: 'Zakelijk',
    // eslint-disable-next-line global-require
    icon: require('@/assets/images/icons/icon1.png').default,
    // eslint-disable-next-line global-require
    audioFile: require('@/assets/audio/snippets/jason_de_ridder-zakelijk.mp4'),
    audioName: uniqueid(),
  },
  {
    value: 'Autoritair',
    // eslint-disable-next-line global-require
    icon: require('@/assets/images/icons/icon2.png').default,
    // eslint-disable-next-line global-require
    audioFile: require('@/assets/audio/snippets/jason_de_ridder-autoritair.mp4'),
    audioName: uniqueid(),
  },
  {
    value: 'Opgewekt',
    // eslint-disable-next-line global-require
    icon: require('@/assets/images/icons/icon3.png').default,
    // eslint-disable-next-line global-require
    audioFile: require('@/assets/audio/snippets/jason_de_ridder-vrolijk.mp4'),
    audioName: uniqueid(),
  },
  {
    value: 'Enthousiast',
    // eslint-disable-next-line global-require
    icon: require('@/assets/images/icons/icon4.png').default,
    // eslint-disable-next-line global-require
    audioFile: require('@/assets/audio/snippets/jason_de_ridder-enthousiast.mp4'),
    audioName: uniqueid(),
  },
  {
    value: 'Pessimistisch',
    // eslint-disable-next-line global-require
    icon: require('@/assets/images/icons/icon5.png').default,
    // eslint-disable-next-line global-require
    audioFile: require('@/assets/audio/snippets/jason_de_ridder-pessimistisch.mp4'),
    audioName: uniqueid(),
  },
  {
    value: 'Speels',
    // eslint-disable-next-line global-require
    icon: require('@/assets/images/icons/icon6.png').default,
    // eslint-disable-next-line global-require
    audioFile: require('@/assets/audio/snippets/jason_de_ridder-speels.mp4'),
    audioName: uniqueid(),
  },
  {
    value: 'Kalm',
    // eslint-disable-next-line global-require
    icon: require('@/assets/images/icons/icon7.png').default,
    // eslint-disable-next-line global-require
    audioFile: require('@/assets/audio/snippets/jason_de_ridder-kalm.mp4'),
    audioName: uniqueid(),
  },
  {
    value: 'Anders',
    // eslint-disable-next-line global-require
    icon: require('@/assets/images/icons/icon8.png').default,
    // eslint-disable-next-line global-require
    audioFile: require('@/assets/audio/snippets/jason_de_ridder-anders.mp4'),
    audioName: uniqueid(),
  },
];

export default {
  components: { ToneOfVoiceSelectorButton },
  name: 'ToneOfVoiceSelector',
  data() {
    return {
      selectedTones: [],
      showError: false,
      toneOfVoices,
    };
  },
  computed: {},
  methods: {
    error() {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 5000);
    },

    select(toneOfVoice) {
      if (toneOfVoice.active) {
        toneOfVoice.active = false;
        this.selectedTones = this.selectedTones.filter((tone) => (tone !== toneOfVoice.value));
      } else if (this.selectedTones.length >= 3) {
        this.error();
        return;
      } else {
        toneOfVoice.active = true;
        this.selectedTones.push(toneOfVoice.value);
      }

      this.$emit('change', this.selectedTones);
    },
  },
};
</script>
